module.exports = __webpack_public_path__ + "static/media/planLogo.ff515134.png";